module.exports = __webpack_public_path__ + "701f45eb2cb69461da94678a44c9a3bd.pdf";